module.exports = __webpack_public_path__ + "static/media/aboutPng.91d0961d.png";